import styled from 'styled-components';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledQuickActionContainer = styled.div.withConfig({
  displayName: "QuickActionStyledComponents__StyledQuickActionContainer",
  componentId: "smp4sj-0"
})(["display:flex;flex-wrap:nowrap;gap:", "px;align-items:stretch;justify-content:stretch;"], ({
  gap = 3
}) => gap);

/* @bend-expect no-styled-foundations-components */
const StyledQuickAction = styled(Clickable).withConfig({
  displayName: "QuickActionStyledComponents__StyledQuickAction",
  componentId: "smp4sj-1"
})(["flex-basis:100%;display:flex;flex-direction:column;align-items:center;border:1px solid ", ";border-radius:3px;:hover{background-color:", ";}background-color:", ";color:", ";", ""], ({
  theme
}) => theme.color['border-interactive-default'], ({
  disabled,
  theme
}) => !disabled && theme.color['fill-info-subtle'], ({
  disabled,
  theme
}) => disabled && theme.color['fill-primary-disabled'], ({
  disabled,
  theme
}) => disabled && theme.color['text-primary-disabled'], ({
  $cssStyles
}) => Object.assign({}, $cssStyles));
export const QuickAction = props => {
  const {
    tokenProps,
    restProps
  } = filterTokenProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);

  // @bend-expect trellis-tokenized
  return /*#__PURE__*/_jsx(StyledQuickAction, Object.assign({
    $cssStyles: cssStyles
  }, restProps));
};